import { useContext } from "react";
import FeatureActivitiesLinks from "components/feature-links/feature-linked-activities";
import FeatureBidPackagesLinks from "components/feature-links/feature-linked-bid-packages";
import FeatureMaterialsLinks from "components/feature-links/feature-linked-materials";
import { ProjectContext } from "context/ProjectProvider";
import "components/feature-links/feature-links.scss";

export function SubmittalDetailLinks(props: {
  featureInstanceData: any;
  canEditLinkingPage: boolean;
  isRevisionMode: boolean;
  isVoidSubmittal: boolean;
  isDeletedSubmittal: boolean;
  isTrackedSubmittal: boolean;
}) {
  const {
    featureInstanceData,
    canEditLinkingPage,
    isRevisionMode,
    isVoidSubmittal,
    isDeletedSubmittal,
    isTrackedSubmittal
  } = props;

  const { isFeatureFlagEnabled } = useContext(ProjectContext);
  const isBuyoutFeatureEnabled = isFeatureFlagEnabled("BUYOUT");

  return (
    <div className="feature-links-card" data-testid="sdl-root">
      {isBuyoutFeatureEnabled && (
        <FeatureBidPackagesLinks
          featureInstanceData={featureInstanceData}
          data-testid="sdl-bid-packages-links"
        />
      )}
      <FeatureMaterialsLinks
        featureInstanceData={featureInstanceData}
        canEditLinkingPage={canEditLinkingPage}
        isRevisionMode={isRevisionMode}
        isVoidSubmittal={isVoidSubmittal}
        isDeletedSubmittal={isDeletedSubmittal}
        isTrackedSubmittal={isTrackedSubmittal}
        data-testid="sdl-materials-links"
      />
      <FeatureActivitiesLinks
        featureInstanceData={featureInstanceData}
        canEditLinkingPage={canEditLinkingPage}
        isRevisionMode={isRevisionMode}
        isVoidSubmittal={isVoidSubmittal}
        isDeletedSubmittal={isDeletedSubmittal}
        isTrackedSubmittal={isTrackedSubmittal}
        data-testid="sdl-activities-links"
      />
    </div>
  );
}
